<template>
	<div class="chat-system-box">
		<el-container>
			<el-header height="50px" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
				<span>{{ chat.showName }}</span>
			</el-header>
			<el-main class="main" id="chatScrollBox" @scroll="onScroll">
				<div v-for="(msgInfo, idx) in chat.messages" :key="idx">
					<div v-if="idx >= showMinIdx">
						<div class="message-box" @click="onClickMessage(msgInfo)"
							v-if="msgInfo.type == $enums.MESSAGE_TYPE.SYSTEM_MESSAGE">
							<div class="title">{{ msgInfo.title }}</div>
							<img class="cover" v-show="msgInfo.coverUrl" :src="msgInfo.coverUrl" />
							<div class="intro">{{ msgInfo.intro }}</div>
							<div class="bottom-bar">查看详情</div>
						</div>
						<div class="message-tip" v-if="msgInfo.type == $enums.MESSAGE_TYPE.TIP_TIME">
							{{ $date.toTimeText(msgInfo.sendTime) }}
						</div>
					</div>
				</div>
			</el-main>
			<chat-system-content ref="contentRef"></chat-system-content>
		</el-container>
	</div>
</template>

<script>
import ChatSystemContent from './ChatSystemContent';

export default {
	name: "chatSystem",
	components: { ChatSystemContent },
	props: {
		chat: {
			type: Object
		}
	},
	data() {
		return {
			showMinIdx: 5
		}
	},
	methods: {
		onClickMessage(msgInfo) {
			this.$refs.contentRef.show(msgInfo.id, msgInfo.title);
		},
		readedMessage() {
			if (this.chat.unreadCount == 0) {
				return;
			}
			let maxSeqNo = this.chatStore.systemMsgMaxSeqNo;
			let url = `/message/system/readed?maxSeqNo=${maxSeqNo}`
			this.$http({
				url: url,
				method: 'put'
			})
		},
		scrollToBottom() {
			this.$nextTick(() => {
				let div = document.getElementById("chatScrollBox");
				div.scrollTop = div.scrollHeight;
			});
		},
		onScroll(e) {
			let scrollElement = e.target
			let scrollTop = scrollElement.scrollTop
			if (scrollTop < 30) { // 在顶部,不滚动的情况
				// 多展示5条信息
				this.showMinIdx = this.showMinIdx > 5 ? this.showMinIdx - 5 : 0;
			}

		},
	},
	watch: {
		chat: {
			handler(newChat, oldChat) {
				this.readedMessage();
				this.scrollToBottom();
				// 初始状态只显示5条消息
				let size = this.chat.messages.length;
				this.showMinIdx = size > 5 ? size - 5 : 0;
			},
			immediate: true
		}
	},
	mounted() {
		let div = document.getElementById("chatScrollBox");
		div.addEventListener('scroll', this.onScroll)
	}
}
</script>

<style lang="scss" scoped>
.chat-system-box {
	display: flex;
	flex-direction: column;
	position: relative;
	width: 100%;
	background: transparent;

	::v-deep .el-header {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: var(--im-font-size-large);
		font-weight: 600;
		letter-spacing: -0.3px;
		color: var(--im-text-color);
		background: rgba(255, 252, 243, 0.62);
		backdrop-filter: blur(24px) saturate(140%);
		-webkit-backdrop-filter: blur(24px) saturate(140%);
		border-bottom: 0.5px solid var(--hairline-soft);
	}

	.main {
		background: transparent;
		margin: 0 3px;
		display: flex;
		flex-direction: column;
		align-items: center;

		.message-box {
			width: 420px;
			background: rgba(255, 252, 243, 0.78);
			backdrop-filter: blur(28px) saturate(150%);
			-webkit-backdrop-filter: blur(28px) saturate(150%);
			border: 0.5px solid var(--glass-border);
			box-shadow:
				inset 0 1px 0 0 var(--glass-border-inner),
				0 1px 2px rgba(31, 31, 35, 0.04),
				0 8px 24px rgba(31, 31, 35, 0.08);
			text-align: left;
			border-radius: var(--radius-lg);
			margin: 16px 0;
			padding: 10px 22px 14px;
			cursor: pointer;
			transition: transform 0.18s cubic-bezier(0.32, 0.72, 0, 1), box-shadow 0.24s ease;

			&:hover {
				transform: translateY(-2px);
				box-shadow:
					inset 0 1px 0 0 var(--glass-border-inner),
					0 12px 30px rgba(91, 141, 238, 0.14);
			}

			.title {
				text-align: center;
				font-size: 17px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				margin: 12px 16px 8px;
				font-weight: 600;
				letter-spacing: -0.3px;
				color: var(--im-text-color);
			}

			.cover {
				width: 100%;
				height: 200px;
				object-fit: cover;
				border-radius: var(--radius-sm);
			}

			.intro {
				padding: 10px 4px 12px;
				font-size: var(--im-font-size);
				color: var(--im-text-color-secondary);
				border-bottom: 0.5px solid var(--hairline-soft);
				overflow-wrap: break-word;
				line-height: 1.55;
			}

			.bottom-bar {
				font-size: var(--im-font-size-small);
				padding: 10px 4px 4px;
				text-align: right;
				color: var(--aurora-blue);
				font-weight: 500;
				transition: color 0.2s ease;

				&::after {
					content: ' ›';
					color: var(--aurora-purple);
				}
			}
		}

		.message-tip {
			line-height: 20px;
			font-size: var(--im-font-size-smaller);
			color: var(--im-text-color-lighter);
			letter-spacing: 0.2px;
			margin-top: 8px;
		}
	}
}
</style>